// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/kpi-settings",
  CreateBulk: "/pyr/kpi-settings",
  Update: "/pyr/kpi-settings",
  ListMasterData: "/pyr/kpi-settings/get-kpi-master-data",
};
